import { useWSMutation } from "../../helpers";
import { QUERY_IDENTITY_VERIFICATION_REQUEST } from "../keys";
import { useWSSnackbar } from "@wingspanhq/fe-component-library";
import { useUserId } from "../../hooks/helpers";
import { startIdentityVerification } from "../../../services/identityVerification/startIdentityVerification";
import { IIdentityVerificationRequestResponse } from "@wingspanhq/users";

export const useStartIdentityVerification = () => {
  const userId = useUserId();
  const { openSnackbar } = useWSSnackbar();

  return useWSMutation(
    async (request: IIdentityVerificationRequestResponse) => {
      return await startIdentityVerification(request.identityVerificationId);
    },
    {
      dependencies(payload, request) {
        return [
          QUERY_IDENTITY_VERIFICATION_REQUEST,
          request.identityVerificationRequestId
        ];
      }
    }
  );
};
